<template>
  <div
    class="manage-content page-card-wrapper page-card-wrapper-adapt-actual-width building-and-room-page"
  >
    <div class="page-card-title">
      <span class="page-card-title-text">{{
        $t('text.Buildings & Rooms')
      }}</span>
    </div>
    <div class="page-card-content">
      <div class="mt-20 page-content">
        <div class="mb-20 section-title">
          <span class="mr-20">{{
            $t('text.organisation').toLowerCase() | firstLetterCapitalize
          }}</span>
          <span>{{ $store.getters[`user/selecteOrganisationName`] }}</span>
        </div>
        <el-row :gutter="10" v-loading="loading">
          <el-col :xs="24" :sm="8">
            <el-checkbox
              class="list-title"
              @change="handleCheckAllBuildingChange"
              :indeterminate="isBuildingIndeterminate"
              v-model="checkedAllBuildings"
              >{{ $t('text.facility_or_building') }}</el-checkbox
            >
            <div class="list-wrapper">
              <el-checkbox-group
                v-model="checkedBuildings"
                @change="handleCheckedBuildingsChange"
                class="list"
              >
                <div
                  class="list-item"
                  :class="{
                    active: building.BuildingId === selectedBuilding.BuildingId
                  }"
                  @click="selectBuilding(building)"
                  v-for="building in allBuildings"
                  :key="building.BuildingId"
                >
                  <el-checkbox :label="building.BuildingId">
                    <el-input
                      v-model="building.BuildingName"
                      size="small"
                      @input="buildingNameChange"
                    ></el-input>
                  </el-checkbox>
                </div>
              </el-checkbox-group>
              <div class="list-operation">
                <div class="add-btn" @click="addBuilding()">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="remove-btn" @click="deleteBuilding('building')">
                  <i class="el-icon-delete-solid"></i>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-checkbox
              class="list-title"
              @change="handleCheckAllFloorChange"
              :indeterminate="isFloorIndeterminate"
              v-model="checkedAllFloors"
              >{{ $t('text.floor') }}</el-checkbox
            >
            <div class="list-wrapper">
              <el-checkbox-group
                v-model="checkedFloors"
                @change="handleCheckedFloorsChange"
                class="list"
              >
                <div v-if="selectedBuilding && selectedBuilding.Floors">
                  <div
                    class="list-item"
                    :class="{ active: floor.FloorId === selectedFloor.FloorId }"
                    @click="selectFloor(floor)"
                    v-for="floor in selectedBuilding.Floors"
                    :key="floor.FloorId"
                  >
                    <el-checkbox :label="floor.FloorId">
                      <el-input
                        v-model="floor.FloorName"
                        size="small"
                        @input="floorNameChange"
                      ></el-input>
                    </el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
              <div class="list-operation">
                <div class="add-btn" @click="addFloor()">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="remove-btn" @click="deleteFloor('floor')">
                  <i class="el-icon-delete-solid"></i>
                </div>
              </div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="8">
            <el-checkbox
              class="list-title"
              @change="handleCheckAllRoomChange"
              :indeterminate="isRoomIndeterminate"
              v-model="checkedAllRooms"
              >{{ $t('text.room') }}</el-checkbox
            >
            <div class="list-wrapper">
              <el-checkbox-group
                v-model="checkedRooms"
                @change="handleCheckedRoomsChange"
                class="list"
              >
                <div v-if="selectedFloor && selectedFloor.Rooms">
                  <div
                    class="list-item"
                    :class="{ active: room.RoomId === selectedRoom.RoomId }"
                    @click="selecteRoom(room)"
                    v-for="room in selectedFloor.Rooms"
                    :key="room.RoomId"
                  >
                    <el-checkbox :label="room.RoomId">
                      <el-input
                        v-model="room.RoomNumber"
                        size="small"
                        @input="roomNumberChange"
                      ></el-input
                    ></el-checkbox>
                  </div>
                </div>
              </el-checkbox-group>
              <div class="list-operation">
                <div class="add-btn" @click="addRoom()">
                  <i class="el-icon-plus"></i>
                </div>
                <div class="remove-btn" @click="deleteRoom('room')">
                  <i class="el-icon-delete-solid"></i>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <AddBuilding
      ref="addBuilding"
      :allBuildings="allBuildings"
      @updateBuilding="getAllBuildings(true)"
    />
    <AddFloor
      ref="addFloor"
      :selectedBuilding="selectedBuilding"
      @updateBuilding="getAllBuildings(true)"
    />
    <AddRoom
      ref="addRoom"
      :selectedFloor="selectedFloor"
      @updateBuilding="getAllBuildings(true)"
    />
  </div>
</template>

<script>
import AddBuilding from '@/components/manage/building/AddBuilding.vue'
import AddFloor from '@/components/manage/building/AddFloor.vue'
import AddRoom from '@/components/manage/building/AddRoom.vue'
import ApiService from '@/services/ApiService.js'
import swal from 'sweetalert'
import _ from 'lodash'
export default {
  data() {
    return {
      allBuildings: [],
      loading: false,
      user: JSON.parse(localStorage.getItem('user')),
      checkedBuildings: [],
      checkedFloors: [],
      checkedRooms: [],
      checkedAllBuildings: false,
      isBuildingIndeterminate: false,
      checkedAllFloors: false,
      isFloorIndeterminate: false,
      checkedAllRooms: false,
      isRoomIndeterminate: false
    }
  },
  components: {
    AddBuilding,
    AddFloor,
    AddRoom
  },
  mounted() {
    this.getAllBuildings()
  },
  computed: {
    selectedBuilding() {
      let selectedBuilding = this.allBuildings.filter(
        building => building.active
      )
      return selectedBuilding.length ? selectedBuilding[0] : {}
    },
    selectedFloor() {
      if (!this.selectedBuilding || !this.selectedBuilding.Floors) return {}
      let selectedFloor = this.selectedBuilding.Floors.filter(
        floor => floor.active
      )
      return selectedFloor.length
        ? selectedFloor[0]
        : this.selectedBuilding.Floors[0]
    },
    selectedRoom() {
      if (!this.selectedFloor || !this.selectedFloor.Rooms) return {}
      let selectedRoom = this.selectedFloor.Rooms.filter(room => room.active)
      return selectedRoom.length ? selectedRoom[0] : this.selectedFloor.Rooms[0]
    }
  },
  watch: {
    selectedBuilding(newVal, oldVal) {
      if (newVal.BuildingId !== oldVal.BuildingId) {
        this.checkedFloors = []
        this.checkedAllFloors = false
        this.isFloorIndeterminate = false
      }
    },
    selectedFloor(newVal, oldVal) {
      if (newVal.FloorId !== oldVal.FloorId) {
        this.checkedRooms = []
        this.checkedAllRooms = false
        this.isRoomIndeterminate = false
      }
    }
  },
  methods: {
    handleCheckAllBuildingChange(val) {
      if (val) {
        this.checkedBuildings = this.allBuildings.map(
          building => building.BuildingId
        )
      } else {
        this.checkedBuildings = []
      }
      this.isBuildingIndeterminate = false
    },
    handleCheckedBuildingsChange(val) {
      this.checkedAllBuildings = val.length === this.allBuildings.length
      this.isBuildingIndeterminate =
        val.length > 0 && val.length < this.allBuildings.length
    },
    handleCheckAllFloorChange(val) {
      if (val && this.selectedBuilding.Floors) {
        this.checkedFloors = this.selectedBuilding.Floors.map(
          floor => floor.FloorId
        )
      } else {
        this.checkedFloors = []
      }
      this.isFloorIndeterminate = false
    },
    handleCheckedFloorsChange(val) {
      if (this.selectedBuilding.Floors) {
        this.checkedAllFloors =
          val.length === this.selectedBuilding.Floors.length
        this.isFloorIndeterminate =
          val.length > 0 && val.length < this.selectedBuilding.Floors.length
      } else {
        this.checkedAllFloors = false
        this.isFloorIndeterminate = false
      }
    },
    handleCheckAllRoomChange(val) {
      if (val && this.selectedFloor.Rooms) {
        this.checkedRooms = this.selectedFloor.Rooms.map(room => room.RoomId)
      } else {
        this.checkedRooms = []
      }
      this.isRoomIndeterminate = false
    },
    handleCheckedRoomsChange(val) {
      if (this.selectedFloor.Rooms) {
        this.checkedAllRooms = val.length === this.selectedFloor.Rooms.length
        this.isRoomIndeterminate =
          val.length > 0 && val.length < this.selectedFloor.Rooms.length
      } else {
        this.checkedAllRooms = false
        this.isRoomIndeterminate = false
      }
    },
    getAllBuildings(keepSelected = false) {
      this.loading = true
      ApiService.GetBuildings(this.$store.getters[`user/selecteOrganisationId`])
        .then(response => {
          this.loading = false
          if (response.data.success) {
            if (keepSelected) {
              this.allBuildings = response.data.data.map(building => {
                return {
                  ...building,
                  Floors: building.Floors.map(floor => {
                    return {
                      ...floor,
                      Rooms: floor.Rooms.map(room => {
                        return {
                          ...room,
                          active: room.RoomId === this.selectedRoom.RoomId
                        }
                      }),
                      active: floor.FloorId === this.selectedFloor.FloorId
                    }
                  }),
                  active:
                    building.BuildingId === this.selectedBuilding.BuildingId
                }
              })
            } else {
              this.allBuildings = response.data.data
              if (this.allBuildings.length) {
                this.$set(this.allBuildings, 0, {
                  ...this.allBuildings[0],
                  Floors: this.allBuildings[0].Floors.map((floor, index) => {
                    return {
                      ...floor,
                      Rooms: floor.Rooms.map((room, index) => {
                        return {
                          ...room,
                          active: index === 0
                        }
                      }),
                      active: index === 0
                    }
                  }),
                  active: true
                })
              }
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },

    selectBuilding(selectedBuilding) {
      this.allBuildings = this.allBuildings.map(building => {
        return {
          ...building,
          Floors: building.Floors.map((floor, index) => {
            return {
              ...floor,
              Rooms: floor.Rooms.map((room, index) => {
                return {
                  ...room,
                  active: index === 0
                }
              }),
              active: index === 0
            }
          }),
          active: building.BuildingId === selectedBuilding.BuildingId
        }
      })
    },
    selectFloor(selectedFloor) {
      this.allBuildings = this.allBuildings.map(building => {
        return {
          ...building,
          Floors: building.Floors.map(floor => {
            return {
              ...floor,
              Rooms: floor.Rooms.map((room, index) => {
                return {
                  ...room,
                  active: index === 0
                }
              }),
              active: floor.FloorId === selectedFloor.FloorId
            }
          })
        }
      })
    },
    selecteRoom(selectedRoom) {
      this.allBuildings = this.allBuildings.map(building => {
        return {
          ...building,
          Floors: building.Floors.map(floor => {
            return {
              ...floor,
              Rooms: floor.Rooms.map(room => {
                return {
                  ...room,
                  active: room.RoomId === selectedRoom.RoomId
                }
              })
            }
          })
        }
      })
    },
    addBuilding() {
      this.$refs.addBuilding.openDialog()
    },
    showWarning(msg) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${msg}.</div>` +
          `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.warning'),
        {
          confirmButtonText: this.$t('text.ok').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      )
    },
    deleteBuilding() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      if (
        this.allBuildings.length === 1 ||
        this.checkedBuildings.length === this.allBuildings.length
      ) {
        this.showWarning(this.$t('text.keep_at_least_one_facility'))
        return
      }
      if (!this.checkedBuildings.length) {
        this.showWarning(this.$t('text.please_select_buildings'))
        return
      }
      let checkedBuildingsName = this.allBuildings
        .filter(building => this.checkedBuildings.includes(building.BuildingId))
        .map(building => building.BuildingName)
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.confirm_deletion'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          checkedBuildingsName.join(','),
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteBuilding()
        })
        .catch(() => {})
    },
    deleteFloor() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      if (
        this.selectedBuilding.Floors.length === 1 ||
        this.checkedFloors.length === this.selectedBuilding.Floors.length
      ) {
        this.showWarning(this.$t('text.keep_at_least_one_floor'))
        return
      }
      if (!this.checkedFloors.length) {
        this.showWarning(this.$t('text.please_select_floors'))
        return
      }
      let checkedFloorsName = this.selectedBuilding.Floors.filter(floor =>
        this.checkedFloors.includes(floor.FloorId)
      ).map(floor => floor.FloorName)
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.confirm_deletion'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          checkedFloorsName.join(','),
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteFloor()
        })
        .catch(() => {})
    },
    deleteRoom() {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      if (
        this.selectedFloor.Rooms.length === 1 ||
        this.checkedRooms.length === this.selectedFloor.Rooms.length
      ) {
        this.showWarning(this.$t('text.keep_at_least_one_room'))
        return
      }
      if (!this.checkedRooms.length) {
        this.showWarning(this.$t('text.please_select_rooms'))
        return
      }
      let checkedRoomNumber = this.selectedFloor.Rooms.filter(room =>
        this.checkedRooms.includes(room.RoomId)
      ).map(room => room.RoomNumber)
      this.$confirm(
        `<div class='warning-content'>${this.$t(
          'text.confirm_deletion'
        )}</div><img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.you_able_to_delete_data') +
          ' ' +
          checkedRoomNumber.join(','),
        {
          confirmButtonText: this.$t('text.delete').toUpperCase(),
          cancelButtonText: this.$t('text.cancel').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          cancelButtonClass: 'cancel-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }
      )
        .then(() => {
          this.handleDeleteRoom()
        })
        .catch(() => {})
    },
    handleDeleteBuilding() {
      this.loading = true
      ApiService.DeleteBuilding(this.checkedBuildings)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getAllBuildings()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleDeleteFloor() {
      this.loading = true
      ApiService.DeleteFloor(this.checkedFloors)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getAllBuildings(true)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    handleDeleteRoom() {
      this.loading = true
      ApiService.DeleteRoom(this.checkedRooms)
        .then(response => {
          this.loading = false
          if (response.data.success) {
            this.getAllBuildings(true)
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    addFloor() {
      this.$refs.addFloor.openDialog()
    },
    addRoom() {
      this.$refs.addRoom.openDialog()
    },
    buildingNameChange: _.debounce(function(val) {
      this.handleBuildingNameChange(val)
    }, 1000),
    handleBuildingNameChange(val) {
      ApiService.SaveBuilding([
        {
          ...this.selectedBuilding,
          BuildingName: val
        }
      ]).then(response => {
        if (response.data.success) {
          this.$message({
            message: this.$t('text.saved_successfully'),
            type: 'success'
          })
        } else {
          this.$message.error(this.$t('text.saved_failed'))
        }
      })
    },
    floorNameChange: _.debounce(function(val) {
      this.handleFloorNameChange(val)
    }, 1000),
    handleFloorNameChange(val) {
      ApiService.SaveFloor([
        {
          ...this.selectedFloor,
          FloorName: val
        }
      ]).then(response => {
        if (response.data.success) {
          this.$message({
            message: this.$t('text.saved_successfully'),
            type: 'success'
          })
        } else {
          this.$message.error(this.$t('text.saved_failed'))
        }
      })
    },
    roomNumberChange: _.debounce(function(val) {
      this.handleRoomNumberChange(val)
    }, 1000),
    handleRoomNumberChange(val) {
      ApiService.SaveRoom([
        {
          ...this.selectedRoom,
          RoomNumber: val
        }
      ]).then(response => {
        if (response.data.success) {
          this.$message({
            message: this.$t('text.saved_successfully'),
            type: 'success'
          })
        } else {
          this.$message.error(this.$t('text.saved_failed'))
        }
      })
    }
  }
}
</script>
